import React from 'react';

function Footer(props){
    return(
        <footer id='footer'>
            <p>&copy;2019 Carlos Aviles Buitron</p>
        </footer>
    );
}

export default Footer;